import React from 'react';
import { Button } from 'flowbite-react';
import { FaGithub, FaGitlab, FaExternalLinkAlt } from 'react-icons/fa';
import { RemoteReference } from 'sched';
import { useNavigate } from 'react-router-dom';

interface RemoteReferenceIconProps {
  reference?: RemoteReference;
  showLabel?: boolean;
  buttonSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

/**
 * A component that displays an icon for a remote reference with an optional label
 * Clicking the icon opens the remote reference URL in a new tab
 */
const RemoteReferenceIcon: React.FC<RemoteReferenceIconProps> = ({
  reference,
  showLabel = false,
  buttonSize = 'sm',
  className = ''
}) => {
  if (!reference) return null;

  // Function to get the appropriate icon based on provider
  const getProviderIcon = () => {
    switch (reference.provider) {
      case "GitHub":
        return <FaGithub className="text-lg" />;
      case "GitLab":
        return <FaGitlab className="text-lg" />;
      default:
        return <FaExternalLinkAlt />;
    }
  };

  // TODO toLocaleString probably doesn't do what we want here
  // Handle click with stopPropagation to prevent row click in tables
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(reference.url, '_blank');
  };

  return (
    <Button
      color="light"
      size={buttonSize}
      onClick={handleClick}
      title={`Open in ${reference.provider}`}
      className={className}
      outline={false}
    >
      {getProviderIcon()}
      {showLabel && (
        <span className="ml-2 hidden sm:inline">
          View in {reference.provider}
        </span>
      )}
    </Button>
  );
};

export default RemoteReferenceIcon;
